export default __webpack_public_path__ + "static/media/3.167bb00d.png";